import { action } from 'typesafe-actions';
import { KpiSETypes, IKpi } from './types';

export const loadRequest = (
  cd: number,
  inscricao: number[],
  dataInicial: string,
  card: string,
  agrupar: number
) =>
  action(KpiSETypes.LOAD_REQUEST, {
    cd,
    dataInicial,
    agrupar,
    card,
    inscricao,
  });

export const loadSuccess = (data: IKpi[]) => action(KpiSETypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(KpiSETypes.LOAD_FAILURE, {});
